import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { DigitalSignageScreensModel } from '@modules/digital-signage/model/screens.model';

export const getDeviceScreens = async (
  params?: any
): Promise<ApiResponse<DigitalSignageScreensModel>> => {
  const response = await axiosInstance.get('/signage/screens/getter', {
    params
  });
  return response.data;
};

export const getDeviceScreensList = async (): Promise<
  DigitalSignageScreensModel[]
> => {
  const response = await axiosInstance.get('/signage/screens');
  return response.data;
};

export const createDeviceScreen = async (
  body?: any
): Promise<DigitalSignageScreensModel> => {
  const response = await axiosInstance.post(`/signage/screens`, body);
  return response.data;
};

export const editDeviceScreenRow = async (
  body?: any,
  id?: string
): Promise<DigitalSignageScreensModel> => {
  const response = await axiosInstance.put(`/signage/screens/${id}`, body);
  return response.data;
};

export const deleteDeviceScreen = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/signage/screens/${id}`);
};

export const deleteDeviceScreenMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/signage/screens/remove-many`, { data });
};
